import { takeLatest, put } from 'redux-saga/effects';

import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';
import {
  actionSetGridDataInvalid,
  actionSetGridDataValid,
} from 'react-redux-app/lib/modules/grid/actions';

import { SITE_FOOTER_LINK_CATEGORIES_GRID_NAME } from '../../constants';

import {
  ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY__REQUEST,
  ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY__SUCCESS,
  ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY__FAIL,

  ACTION_CREATE_SITE_FOOTER_LINK_CATEGORY__REQUEST,
  ACTION_CREATE_SITE_FOOTER_LINK_CATEGORY__SUCCESS,
  ACTION_CREATE_SITE_FOOTER_LINK_CATEGORY__FAIL,

  ACTION_EDIT_SITE_FOOTER_LINK_CATEGORY__REQUEST,
  ACTION_EDIT_SITE_FOOTER_LINK_CATEGORY__SUCCESS,
  ACTION_EDIT_SITE_FOOTER_LINK_CATEGORY__FAIL,

  ACTION_SET_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__REQUEST,
  ACTION_SET_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__SUCCESS,
  ACTION_SET_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__FAIL,

  ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__REQUEST,
  ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__SUCCESS,
  ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__FAIL,
} from '../../actionTypes';


function* disableGrid() {
  try {
    yield put(actionSetGridDataInvalid(SITE_FOOTER_LINK_CATEGORIES_GRID_NAME));
  } catch (e) {
    yield put(actionAddException(e));
  }
}

function* enableGrid() {
  try {
    yield put(actionSetGridDataValid(SITE_FOOTER_LINK_CATEGORIES_GRID_NAME));
  } catch (e) {
    yield put(actionAddException(e));
  }
}

export default function* saga() {
  yield takeLatest([
    ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY__REQUEST,
    ACTION_CREATE_SITE_FOOTER_LINK_CATEGORY__REQUEST,
    ACTION_EDIT_SITE_FOOTER_LINK_CATEGORY__REQUEST,
    ACTION_SET_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__REQUEST,
    ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__REQUEST,
  ], disableGrid);

  yield takeLatest([
    ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY__SUCCESS,
    ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY__FAIL,
    ACTION_CREATE_SITE_FOOTER_LINK_CATEGORY__SUCCESS,
    ACTION_CREATE_SITE_FOOTER_LINK_CATEGORY__FAIL,
    ACTION_EDIT_SITE_FOOTER_LINK_CATEGORY__SUCCESS,
    ACTION_EDIT_SITE_FOOTER_LINK_CATEGORY__FAIL,
    ACTION_SET_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__SUCCESS,
    ACTION_SET_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__FAIL,
    ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__SUCCESS,
    ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__FAIL,
  ], enableGrid);
}
